import axios from '@customAxios';
var API_BASE_URL = '/api/blog';
var Butter = axios.create({
    baseURL: API_BASE_URL,
});
export var getApiKey = function () {
    return Butter.get('/key', {
        headers: { 'Cache-Control': 'no-cache' },
    });
};
